import type { FaireProductEntity } from "../../entity_types/product";

export const p_juex45tn7n: FaireProductEntity = {
  token: "p_juex45tn7n",
  type: "product",
  name: "Twist Chain Necklace (2mm, Silver)",
  brandToken: "b_es7mn9nt",
  brandName: "EMESLY",
  imageUrl:
    "https://cdn.faire.com/fastly/308c570f363b2c4404bf69a833936cfc319044cbc179532b15b06a2acf118e8e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56cbd6d241f3872ac259aea0ed257cd5747c8001bb47d8022a8140e095c37d10.png",
    "https://cdn.faire.com/fastly/5ef6c3fb332d804118ed020074330deb9ad6f206f01f00bdbebd98c8fc9e8bb6.png",
    "https://cdn.faire.com/fastly/07d984a477c85ab9caf626ed4f4896beeb0a852ab9f9bf44648bf1749ce27ad6.png",
    "https://cdn.faire.com/fastly/f7177d9fc70e9593ce9c6b32741669a53ba7d86b5b8e0e4385514d36168dd958.png",
  ],
  priceDollars: 2.99,
  description:
    "\nEmesly Twist Chain Necklace | Give a modern urban edge to a casual t-shirt, hoodie, or formal outfit. Wear solo for an everyday polished look or add a favorite pendant or charm for a cool personal statement.\n\nMaterial: This beautiful necklace is white gold plated; is crafted to be durable for easy all-day wear and has a long-lasting brilliant hypoallergenic high polish finish.\n",
  tags: [],
  msrpDollars: 5.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:55.603Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
